import { theme } from "antd";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { useState, useEffect } from "react";
import { EnquiryReportRes } from "../../../../../response/enquiry.response";
import { getGraphColor } from "../../../../../enum/static-data.enum";
import { useNavigate } from "react-router-dom";

export interface EnquireChartComponentProp {
    enquiryReportResList: EnquiryReportRes[]
    filterData: any
}

const EnquireChartComponent = (props: EnquireChartComponentProp) => {

    const navigate = useNavigate();
    
    const { enquiryReportResList, filterData } = props

    const { useToken } = theme;
    const { token } = useToken();
    const [chartHeight, setChartHeight] = useState('280px')

    const dataList = enquiryReportResList.map((enquiryReportRes: EnquiryReportRes) => {
        return {
            name: enquiryReportRes.value,
            y: enquiryReportRes.count,
            color: getGraphColor(enquiryReportRes.value),
            drilldown: enquiryReportRes.value
        }
    })

    const options = {
        chart: {
            type: 'pie',
            height: chartHeight
        },

        title: {
            text: '',
            align: 'left'
        },
        credits: {
            enabled: false
        },
        accessibility: {
            announceNewData: {
                enabled: true
            },
            point: {
                valueSuffix: ''
            }
        },
        plotOptions: {
            series: {
                borderRadius: 5,
                dataLabels: {
                    enabled: true,
                    format: '{point.name}: {point.y:.0f}'
                }
            }
        },

        series: [{
            name: 'Enquiry',
            colorByPoint: true,
            data: dataList,
            point: {
                events: {
                    click: function (event: any) {
                        onPieClick((this as any).name)
                    }
                }
            }
        }]
    }

    useEffect(() => {
        const isMobile = window.innerWidth <= 768; // Adjust the breakpoint according to your needs
        const ch = isMobile ? '200px' : '280px';
        setChartHeight(ch)
    }, [])

    const onPieClick = (status: string) => {
        navigate('/enquiry', {
            state: {
                filterData: filterData,
                status: status
            }
        });
    }

    return (
        <HighchartsReact highcharts={Highcharts} options={options} />
    )
}

export default EnquireChartComponent